import Nanobus from "nanobus";
// @ts-ignore
import $ from 'jquery';
export const initWidthSetting = (column) => {
    column.getElement().querySelectorAll('table[data-setting="width"]').forEach(setting => new WidthSetting(column, setting));
};
class WidthSetting {
    constructor(column, setting) {
        this.column = column;
        this.setting = setting;
        this.events = new Nanobus();
        this.indicator = new WidthIndicator(column.getElement().querySelector('.ac-column-heading-setting--width'));
        this.widthInput = this.setting.querySelector('[data-width-input]');
        this.unitInput = this.setting.querySelectorAll('[data-unit-input] input');
        this.init();
    }
    getWidth() {
        let widthValue = this.widthInput.value;
        return widthValue ? parseInt(widthValue) : null;
    }
    setWidth(width) {
        this.widthInput.value = width ? width.toString() : null;
        this.updateIndicator();
    }
    updateUnit() {
        this.setting.querySelector('.description .unit').innerHTML = this.getUnit();
    }
    getUnit() {
        let input = this.setting.querySelector('[data-unit-input] input:checked');
        return input ? input.value : null;
    }
    getValue() {
        return {
            width: this.getWidth(),
            unit: this.getUnit()
        };
    }
    validate() {
        let width = this.getWidth();
        if (width === 0 || width < 0) {
            this.setWidth(null);
        }
        if (this.getUnit() === '%') {
            if (width > 100) {
                this.setWidth(100);
            }
        }
    }
    init() {
        this.widthInput.addEventListener('keyup', () => {
            this.updateIndicator();
            this.initSlider();
            this.validate();
        });
        this.unitInput.forEach(el => {
            el.addEventListener('change', () => {
                this.initSlider();
                this.updateIndicator();
                this.updateUnit();
                this.validate();
            });
        });
        this.initSlider();
    }
    updateIndicator() {
        this.indicator.setValue(this.getWidth(), this.getUnit());
    }
    initSlider() {
        let sliderElement = this.column.getElement().querySelector('.width-slider');
        $(sliderElement).slider({
            range: 'min',
            min: 0,
            max: '%' === this.getUnit() ? 100 : 500,
            value: this.getWidth(),
            slide: (event, ui) => {
                this.setWidth(ui.value);
            }
        });
    }
}
class WidthIndicator {
    constructor(element) {
        this.element = element;
        this.events = new Nanobus();
    }
    setValue(width, unit) {
        if (width === null) {
            return this.element.innerText = '';
        }
        this.element.innerText = `${width.toString()}${unit}`;
    }
}
